// extracted by mini-css-extract-plugin
export var root = "styles-module--root--1c78P";
export var about = "styles-module--about--1URMc";
export var noteCard = "styles-module--noteCard--85BZM";
export var titleWrapper = "styles-module--titleWrapper--17Ecu";
export var callOut = "styles-module--callOut--1ZROL";
export var bold = "styles-module--bold--2OkBS";
export var highlight = "styles-module--highlight--2pxKA";
export var button = "styles-module--button--3LNBo";
export var img = "styles-module--img--busAu";
export var noteTitle = "styles-module--noteTitle--RzWjC";
export var noteImg = "styles-module--noteImg--223Zv";